import { AppContainerId, Device, HtmlId } from '../enum';
import { createTabs } from '@vfde-brix/ws10/tabs';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Create Brix Tabs component.
 * @param {HtmlId} id - ID of the element.
 * @returns {Tabs | null} component or null if element with given id is not found
 */
export const mountTabs = (id: HtmlId) =>
    createComponentById(createTabs, id, NO_PATTERN_BUSINESS_LOGIC);

export const updateActiveDeviceTab = (device: Device) => {
    const activeId = device === Device.HOMEBOX
        ? AppContainerId.DEVICE_TABS_HOMEBOX_BUTTON
        : AppContainerId.DEVICE_TABS_SOUNDBOX_BUTTON;

    // updating the component would result in re-rendering the whole content
    // and any component inside would have to be re-mounted by hand
    document.getElementById(activeId)?.click();
};
